import { styled } from '@mui/material';

export const Container = styled('div')(({ theme }) => ({
  '&:hover,&:focus': {
    '& .listItemSubTitle': {
      color: theme.supportingTextSecondary,
    },
    '& .listItemTitle > a': {
      color: theme.mainTextSecondary,
    },
    '& .moreOptionsButton': {
      color: theme.mainTextSecondary,
    },
    '& .tagline': {
      color: theme.mainTextSecondary,
    },
    '& .voteAverageText': {
      color: theme.mainTextSecondary,
    },
    backgroundColor: theme.backgroundPrimary,
    boxShadow: `0 0 0 ${theme.spacing(1)} ${theme.backgroundPrimary}`,
  },
  borderRadius: theme.spacing(0.5),
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
}));

export const SkeletonContainer = styled('div')(({ theme }) => ({
  borderRadius: theme.spacing(0.5),
  display: 'flex',
}));

export const Content = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  paddingTop: theme.spacing(1),
  width: '100%',
}));

export const PrimaryContent = styled('div')();

export const SupportingContent = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  marginTop: theme.spacing(0.5),
}));
